import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Ordered = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconContainerClass = `${styles.LeftNavIconLinkContainer} ${
    styles.IconLinkContainer
  } ${isActive ? styles.Active : ''}`;
  const orderedLink: string = `${styles.LinkRight} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faClock}
      iconClassName={styles.Icon}
      iconContainerClassName={iconContainerClass}
      textClassName={orderedLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Ordered;
